import { render, staticRenderFns } from "./TheSidenav.vue?vue&type=template&id=38b0bc0d&scoped=true&"
import script from "./TheSidenav.vue?vue&type=script&lang=js&"
export * from "./TheSidenav.vue?vue&type=script&lang=js&"
import style0 from "./TheSidenav.vue?vue&type=style&index=0&id=38b0bc0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0bc0d",
  null
  
)

export default component.exports